import React from 'react'
import {
    AlertOutlined,
    ProfileOutlined,
    BarChartOutlined,
    FileTextOutlined,
    FolderOpenOutlined,
    HomeOutlined,
    QuestionCircleOutlined,
    QuestionOutlined,
    RightOutlined,
    SettingOutlined,
    SmileOutlined,
    UsergroupAddOutlined,
    UserOutlined,
} from '@ant-design/icons';
import {IntlShape} from "react-intl/src/types";
import {getI18n} from '../utils/Utils';
import { OBT_ACCESS_ENTITLEMENTS } from '../pages/obt/obtEntitlements';

const Folder = () => <img src="../images/open_rg_d_48_def.png" alt="Custom Icon" style={{ width: '20px', height: '20px' }}  />;

export default function sideMenu(intl: IntlShape) {
    return {
        route: {
            routes: [
                {
                    path: "/",
                    redirect: "/welcome"
                },
                {
                    path: "/welcome",
                    name: getI18n("mainlayout-welcome", "Welcome", intl),
                    phraseId: "mainlayout-welcome",
                    icon: <HomeOutlined style={{ color: '#faf5f5', fontSize: '20px' }} />,
                    component: "/pages/Welcome"
                },

                {
                    name: getI18n("mainlayout-my-onboarding", "My Onboarding", intl),
                    phraseId: "mainlayout-my-onboarding",
                    path: "/survey/surveyLandingPage",
                    icon: <FileTextOutlined style={{ color: '#faf5f5' , fontSize: '20px'}} />,
                    routes: [
                        {
                            path: "/survey/survey-overview",
                            classNames: 'menu-item-margin',
                            name: getI18n("mainlayout-survey-einvoicing", "Survey eInvoicing", intl),
                            phraseId: "mainlayout-survey-einvoicing",
                            icon: <RightOutlined/>,
                            component: "pages/survey/SurveyOverview",
                            entitlement: "menu_onboarding_einv@survey"
                        },
                        {
                            path: "/survey/survey-management",
                            name: getI18n("mainlayout-management-overview", "Management Overview", intl),
                            classNames: 'menu-item-margin',
                            phraseId: "mainlayout-management-overview",
                            icon: <RightOutlined/>,
                            component: "pages/survey/SurveyManagement",
                            entitlement: "internal_viewer@portal"
                        },
                        {
                            path: "/obt/partner-overview",
                            name: getI18n("mainlayout-onboarding-tool", "ONBOARDING TOOL", intl).toUpperCase(),
                            classNames: 'menu-item-margin',
                            phraseId: "mainlayout-onboarding-tool",
                            icon: <RightOutlined/>,
                            component: "pages/obt/ObtLandingPage",
                            entitlement: OBT_ACCESS_ENTITLEMENTS
                        }
                    ]
                },
                {
                    name: intl.formatMessage({id: "mainlayout-my-documents"}),
                    path: "/documents/documents-landing",
                    phraseId: "mainlayout-my-documents",
                    icon: <FolderOpenOutlined style={{ color: '#faf5f5' , fontSize: '20px'}} />,
                    routes: [
                        {
                            path: "/documents/transportation",
                            name: getI18n("mainlayout-freight", "Freight", intl),
                            phraseId: "mainlayout-freight",
                            icon: <RightOutlined/>,
                            component: "pages/documents/myDocuments",
                            entitlement: "menu_documents@freight"
                        },
                        {
                            name: getI18n("mainlayout-ecap-portal-menu", "eCAP", intl),
                            phraseId: "mainlayout-ecap-portal-menu",
                            path: "/e-cap-welcome",
                            component: "pages/EcapWelcome",
                            entitlement: "create_dp@ecap",
                            icon: <Folder/>,
                            routes: [
                                {
                                    path: "/e-cap-welcome",
                                    name: getI18n("mainlayout-ecap-portal-hint-text", "eCap Portal", intl),
                                    phraseId: "mainlayout-ecap-portal",
                                    icon: <RightOutlined/>,
                                    component: "pages/EcapWelcome",
                                    entitlement: "create_dp@ecap"
                                },
                                {
                                    path: "/ecap/document-processing",
                                    name: getI18n("mainlayout-ecap-capture-document-hint-text", "eCAP Capture Document", intl),
                                    phraseId: "mainlayout-Capture-Document-title",
                                    icon: <RightOutlined/>,
                                    entitlement: "create_dp@ecap"
                                },
                                {
                                    path: "/ecap/manage-templates",
                                    name: getI18n("mainlayout-ecap-manage-templates-hint-text", "eCAP Manage Templates", intl),
                                    phraseId: "mainlayout-Manage-Template-title",
                                    icon: <RightOutlined/>,
                                    entitlement: "create_dp@ecap"
                                },
                                {
                                    path: "/e-cap/draft-documents",
                                    name: getI18n("mainlayout-List-Draft-Documents-hint-text", "eCAP Draft Documents", intl),
                                    phraseId: "mainlayout-List-Draft-Documents-title",
                                    icon: <RightOutlined/>,
                                    entitlement: "create_dp@ecap"
                                },
                                {
                                    path: "/e-cap/po-flip",
                                    name: getI18n("purchase-order-flip", "PURCHASE ORDER FLIP", intl),
                                    phraseId: "purchase-order-flip",
                                    icon: <RightOutlined/>,
                                    entitlement: "create_dp@ecap"
                                }
                            ]
                        },
                        {
                            path: "/documents/documents-overview",
                            name: getI18n("mainlayout-List-Documents-hint-text", "DOCUMENTS OVERVIEW", intl),
                            phraseId: "mainlayout-list-document",
                            icon: <RightOutlined/>,
                            component: "pages/documents/DocumentsOverview",
                            entitlement: "*overview@documents"
                        }
                    ]
                },
                {
                    name: getI18n("mainlayout-my-reports", "MY REPORTS", intl),
                    path: "/reports/reports-landing",
                    phraseId: "mainlayout-my-reports",
                    entitlement: "*@reports",
                    icon: <BarChartOutlined style={{color: '#faf5f5' , fontSize: '20px'}}/>,
                    routes: [
                        {
                            path: "/reports/account-payable-reports",
                            name: getI18n("accounts-payable", "ACCOUNTS PAYABLE", intl),
                            phraseId: "accounts-payable",
                            classNames: "menu-item-margin menu-item-capitalize",
                            icon: <RightOutlined/>,
                            component: "pages/info-portal/components/AccountPayableReports",
                            entitlement: ["display_sr@reports", "display_nr@reports", "display_cz@reports","display_coa@reports","display_ly@reports"]
                        },
                        {
                            path: "/reports/internal-reports",
                            name: getI18n("internal-reports", "INTERNAL REPORTS", intl),
                            phraseId: "internal-reports",
                            classNames: "menu-item-margin menu-item-capitalize",
                            icon: <RightOutlined/>,
                            component: "pages/info-portal/components/InternalReports",
                            entitlement: "display_kp*@reports"
                        },
                        {
                            path: "/reports/tnr-reports",
                            name: getI18n("accounts-receivable", "ACCOUNTS RECEIVABLE", intl),
                            phraseId: "accounts-receivable",
                            classNames: "menu-item-margin menu-item-capitalize",
                            icon: <RightOutlined/>,
                            component: "pages/info-portal/components/AccountReceivableReports",
                            entitlement: "display_tnr@reports"
                        }
                    ]
                },
                {
                    name: getI18n("mainlayout-my-monitoring", "My Monitoring", intl).toUpperCase(),
                    phraseId: "mainlayout-my-monitoring",
                    path: "/documents/eim/monitoring",
                    entitlement: ["display@monitoring", "display@e2e_monitoring", "beta_features@system"],
                    icon: <AlertOutlined style={{color: '#faf5f5' , fontSize: '20px'}}/>,
                    routes: [
                        {
                            path: "/eim-document-dashboard-monitoring",
                            name: getI18n("eim-document-dashboard-monitoring-menu-item", "Monitoring Dashboard", intl).toUpperCase(),
                            phraseId: "eim-document-dashboard-monitoring-menu-item",
                            icon: <ProfileOutlined/>,
                            entitlement: "display@monitoring"
                        },
                        {
                            path: "/eim-document-overview-monitoring",
                            name: getI18n("eim-document-overview-monitoring-menu-item", "Monitoring Overview", intl).toUpperCase(),
                            phraseId: "eim-document-overview-monitoring-menu-item",
                            icon: <ProfileOutlined/>,
                            entitlement: ["update@monitoring", "display@monitoring"]
                        },
                        {
                            path: "/eim-document-executive-dashboard-monitoring",
                            name: getI18n("eim-document-executive-dashboard-menu-item", "Executive Dashboard", intl).toUpperCase(),
                            phraseId: "eim-document-executive-dashboard-menu-item",
                            icon: <ProfileOutlined/>,
                            requiredEntitlements: "beta_features@system"
                        },
                        {
                            path: "/eim-document-executive-dashboard-monitoring-v2",
                            name: getI18n("eim-document-executive-dashboard-v2-menu-item", "E2E Monitor", intl).toUpperCase(),
                            phraseId: "eim-document-executive-dashboard-v2-menu-item",
                            icon: <ProfileOutlined/>,
                            entitlement: "display@e2e_monitoring"
                        },
                        {
                            path: "/country-performance-monitoring",
                            name: getI18n("country-performance-monitoring-menu-item", "Country Performance Monitoring", intl).toUpperCase(),
                            phraseId: "country-performance-monitoring-menu-item",
                            icon: <ProfileOutlined/>,
                            requiredEntitlements:  "beta_features@system"
                        },
                        {
                            path: "/cfo-reporting-dashboard",
                            name: getI18n("cfo-reporting-menu-item", "CFO Reporting", intl).toUpperCase(),
                            phraseId: "cfo-reporting-menu-item",
                            icon: <ProfileOutlined/>,
                            requiredEntitlements: "beta_features@system"
                        },
                        {
                            path: "/cfo-compliance-report",
                            name: getI18n("cfo-compliance-menu-item", "CFO Compliance Report", intl).toUpperCase(),
                            phraseId: "cfo-compliance-menu-item",
                            icon: <ProfileOutlined/>,
                            requiredEntitlements: "beta_features@system"
                        },
                        {
                            path: "/bmw-einvoicing-performance-dashboard",
                            name: getI18n("bmw-einvoicing-performance-dashboard-menu-item", "BMW eInvoicing Performance Dashboard", intl).toUpperCase(),
                            phraseId: "bmw-einvoicing-performance-dashboard-menu-item",
                            icon: <ProfileOutlined/>,
                            requiredEntitlements: "beta_features@system"
                        }
                    ]
                },
                {
                    name: getI18n("mainlayout-technical-management", "TECHNICAL MANAGEMENT", intl),
                    classNames: "menu-item-margin menu-item-capitalize",
                    path: "/documents/technical-dashboard-welcome-menu",
                    phraseId: "mainlayout-technical-management-portal",
                    entitlement: "technicaldashboard@systemadmin",
                    icon: <SettingOutlined style={{color: '#faf5f5' , fontSize: '20px'}} />,
                    routes: [
                        {
                            path: "/entitlements/main",
                            name: getI18n("mainlayout-entitlements-dashboard", "ENTITLEMENTS", intl),
                            phraseId: "mainlayout-entitlements-dashboard",
                            classNames: "menu-item-margin menu-item-capitalize",
                            icon: <RightOutlined/>,
                            component: "/pages/entitlement_maintenance/entitlementMain",
                            entitlement: "view@entitlements"
                        },
                        {
                            path: "/masterData/main",
                            name: getI18n("mainlayout-master-data-dashboard", "MASTER DATA", intl),
                            phraseId: "mainlayout-master-data-dashboard",
                            classNames: "menu-item-margin menu-item-capitalize",
                            icon: <RightOutlined/>,
                            component: "/pages/dashboard/MasterDataMaintenance/MasterDataMain",
                            entitlement: "technicaldashboard@systemadmin"
                        },
                        {
                            path: "/documents/info-log",
                            name: getI18n("mainlayout-info-log-dashboard", "INFO-LOG", intl),
                            phraseId: "mainlayout-info-log-dashboard",
                            classNames: "menu-item-margin menu-item-capitalize",
                            icon: <RightOutlined/>,
                            component: "/pages/e-cap/reprocess-info-log/InfoLogMain",
                            entitlement: "technicaldashboard@systemadmin"
                        },
                        {
                            path: "/documents/dashboard",
                            name: getI18n("mainlayout-freight-documents", "FREIGHT DOCUMENTS", intl),
                            phraseId: "mainlayout-freight-documents",
                            classNames: "menu-item-margin menu-item-capitalize",
                            icon: <RightOutlined/>,
                            component: "/pages/dashboard/Dashboard",
                            entitlement: "technicaldashboard@systemadmin"
                        },
                        {
                            path: "/documents/notifications-management/NotificationManagement",
                            name: getI18n("mainlayout-notifications-management", "NOTIFICATIONS MANAGEMENT", intl),
                            phraseId: "mainlayout-notifications-management",
                            classNames: "menu-item-margin menu-item-capitalize",
                            icon: <RightOutlined/>,
                            component: "/pages/notifications/notifications-management/NotificationManagement",
                            entitlement: "technicaldashboard@systemadmin"
                        },
                        {
                            path: "/documents/banner-management",
                            name: getI18n("mainlayout-banner-management", "BANNER MANAGEMENT", intl).toUpperCase(),
                            phraseId: "mainlayout-banner-management",
                            classNames: "menu-item-margin menu-item-capitalize",
                            icon: <RightOutlined/>,
                            component: "/pages/dashboard/BannerManagement",
                            entitlement: "technicaldashboard@systemadmin"
                        },
                        {
                            path: "/documents/missing-invoices",
                            name: getI18n("mainlayout-missing-invoices", "ECAP MISSING INVOICES", intl).toUpperCase(),
                            phraseId: "mainlayout-missing-invoices",
                            classNames: "menu-item-margin menu-item-capitalize",
                            icon: <RightOutlined/>,
                            component: "/pages/dashboard/missing_invoices/TechMissingInvoices",
                            entitlement: "technicaldashboard@systemadmin"
                        },
                        {
                            path: "/reports/admin",
                            name: getI18n("report-admin-menu-label", "REPORTS ADMIN", intl).toUpperCase(),
                            phraseId: "report-admin-menu-label",
                            classNames: "menu-item-margin menu-item-capitalize",
                            icon: <RightOutlined/>,
                            component: "/pages/info-portal/components/admin/ReportingConfiguration",
                            entitlement: "config_admin@reports"
                        },
                        {
                            path: "/user-guide-management",
                            name: getI18n("user-guide-management", "USER GUIDE MANAGEMENT", intl).toUpperCase(),
                            phraseId: "user-guide-management",
                            classNames: "menu-item-margin menu-item-capitalize",
                            icon: <RightOutlined/>,
                            entitlement: "technicaldashboard@systemadmin"
                        }
                    ]
                },
                {
                    name: getI18n("mainlayout-user-management", "USER MANAGEMENT", intl),
                    phraseId: "mainlayout-user-management",
                    icon: <UserOutlined style={{ color: '#faf5f5', fontSize: '20px' }} />,
                    path: "/users",
                    component: "/pages/Users",
                    entitlement: "usermanagement@systemadmin"
                },
                {
                    path: "/help-faq-user-guides",
                    name: getI18n("mainlayout-help", "Help / FAQ", intl).toUpperCase(),
                    phraseId: "mainlayout-help",
                    icon: <QuestionCircleOutlined style={{color: '#faf5f5' , fontSize: '20px'}} />,
                    entitlement: "*"
                }
            ]
        },
        location: {
            pathname: '/'
        }
    }
}